module.exports = __webpack_public_path__ + "static/media/mesonry-cat2-md-6.ac78f581.jpg";